import React, { useEffect } from "react";
import { Typography, Space, Button, message } from "antd";
import { useSubState } from "../State.js";
import { useNavigate } from "react-router-dom";
import BackButton from "@/note_office/shared/BackButton";
import axios from "axios";
import Helper from "@/helper";
import translator from "@/translator";

const t = translator("note_office.views.subscriptions.index_view.sub_payment_approve.");

const { Text, Title } = Typography;

const SubPaymentApprove = ({}) => {
  const { state } = useSubState();
  const navigate = useNavigate();

  const calcSumDiff = (selected_plan) => {
    return Math.ceil(selected_plan.highest_price_special - selected_plan.lowest_price_special);
  };

  useEffect(() => {
    if (!state.selected_plan.name) {
      navigate("/new");
    }
  }, []);

  const subscriptionDeleteRequest = () => {
    axios({
      method: "DELETE",
      url: state.subscriptions_url,
      headers: {
        "X-CSRF-TOKEN": Helper.getCSRFToken(),
      },
    }).then((response) => {
      const res_data = response.data;
      if (res_data.redirect_to) {
        window.location.href = res_data.redirect_to;
      }

      if (res_data.errors) {
        res_data.errors.map((error) => {
          message.error(error);
        });
      }
    });
  };

  const paymentRequest = () => {
    axios({
      method: "POST",
      data: {
        ...state.sub_form_params,
        sum: parseInt(state.sum),
        paid_period: parseInt(state.paid_period),
        subscription_plan_id: state.selected_plan.id,
      },
      url: state.payment_url,
      headers: {
        "X-CSRF-TOKEN": Helper.getCSRFToken(),
      },
    }).then((response) => {
      const res_data = response.data;
      if (res_data.redirect_to) {
        window.location.href = res_data.redirect_to;
      }

      if (res_data.errors) {
        res_data.errors.map((error) => {
          message.error(error);
        });
      }
    });
  };

  const onSubmit = () => {
    if (state.selected_plan.name == "Free") {
      return subscriptionDeleteRequest();
    } else {
      return paymentRequest();
    }
  };

  return (
    <div className="wrapper wrapper__menu-layout overflow">
      <div className="subscription-sub_payment_approve">
        <Space>
          <BackButton onClick={() => navigate("/new")} title={t("title")} />
        </Space>
        <Space direction="vertical">
          <Title level={4}>
            {t("sub_title", { name: state.selected_plan.name })}{" "}
            {t("sub_title_counter", { count: state.paid_period })}
          </Title>
          <Space direction="vertical" className="subscription-sub_payment_approve__space">
            <div className="subscription-sub_payment_approve__text_box">
              <Text>{t("full_sum")}</Text>{" "}
              <Text>{`${state.selected_plan.highest_price_special} ${state.localized_currency_unit}`}</Text>
            </div>

            <div className="subscription-sub_payment_approve__text_box">
              <Text>{t("discount")}</Text>{" "}
              <Text>{`${calcSumDiff(state.selected_plan)} ${state.localized_currency_unit}`}</Text>
            </div>

            <div className="subscription-sub_payment_approve__text_box">
              <Text>{t("bonus")}</Text> <Text>{`0 ${state.localized_currency_unit}`}</Text>
            </div>
          </Space>
          <div className="subscription-sub_payment_approve__text_box">
            <Title
              className="subscription-sub_payment_approve__space subscription-sub_payment_approve__text_box"
              level={4}
            >
              <div>{t("total")}</div>
              <div>{`${state.sum} ${state.localized_currency_unit}`}</div>
            </Title>
          </div>
        </Space>

        <Button
          type="primary"
          block
          className="subscription-form__payment-button"
          size="large"
          onClick={onSubmit}
        >
          {t("submit", { sum: `${state.sum} ${state.localized_currency_unit}` })}
        </Button>
      </div>
    </div>
  );
};

export default SubPaymentApprove;
